import React, {useState} from "react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';



const Buttons = ({ FilterCategory, allCategories }) => {
  const [personName, setPersonName] = useState('');
  // console.log(personName);
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    const get_Value = event.target.value;
    // console.log(get_Value);
    setPersonName(get_Value);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <section className="pos-btn-select-ab">  
    <FormControl sx={{ m: 1, width: 155}}>
        <InputLabel id="demo-controlled-open-select-label" 
        className={`${open ? " ml-1":"mt-[-8px]"} text-[#0080ff!important]`}>Choose Type</InputLabel>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={personName}
          label="Choose Type"
          onChange={handleChange}
          className="capitalize h-10"
        >
          {allCategories?.map((category, index) => {
        return (
          <MenuItem
            key={index}
            onClick={() => FilterCategory(category)}
            className="btn-type uppercase"
            value={category}
          >
            {category}
          </MenuItem>
        );
      })}
        </Select>
      </FormControl>
    </section>
  );
};

export default Buttons;



{/* <div className="button-container">
      {allCategories.map((category, index) => {
        return (
          <button
            key={index}
            onClick={() => FilterCategory(category)}
            className="btn-type"
          >
            {category}
          </button>
        );
      })}
    </div> */}